import { render, staticRenderFns } from "./ProchainsServices.vue?vue&type=template&id=4b939150&scoped=true"
import script from "./ProchainsServices.vue?vue&type=script&lang=js"
export * from "./ProchainsServices.vue?vue&type=script&lang=js"
import style0 from "./ProchainsServices.vue?vue&type=style&index=0&id=4b939150&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b939150",
  null
  
)

export default component.exports